import {
  PersistedFormGroup,
  PersistedFormArray,
  PersistedArray,
} from './persisted-form-group';
import type {
  PersistedFormGroupOptions,
  PersistedFormArrayOptions,
  PersistedArrayOptions,
} from './persisted-form-group';
import type { SchemaFormControl } from '@apexdesigner/schema-forms';
import { InterviewTeamwork } from './interview-teamwork';
export { InterviewTeamwork };
import { interviewTeamworkSchema } from '@schemas/business-objects/interview-teamwork';
import { InterviewFormGroup } from './interview-form-group';

export class InterviewTeamworkFormGroup extends PersistedFormGroup {
  declare controls: {
    id: SchemaFormControl;
    teamworkScore: SchemaFormControl;
    leadershipScore: SchemaFormControl;
    notes: SchemaFormControl;
    interviewId: SchemaFormControl;
    interview: InterviewFormGroup;
  };

  declare value: Partial<InterviewTeamwork>;

  constructor(
    data?: Record<string, any> | null,
    options?: PersistedFormGroupOptions,
  ) {
    super(interviewTeamworkSchema, InterviewTeamwork, data, options);
  }

  get object(): InterviewTeamwork {
    return new InterviewTeamwork(this.getRawValue());
  }

  protected override createControl(name: string) {
    switch (name) {
      case 'interview':
        return new InterviewFormGroup();
      default:
        return undefined;
    }
  }
}

export class InterviewTeamworkFormArray extends PersistedFormArray {
  readonly entityName = 'InterviewTeamwork' as const;

  constructor(options?: PersistedFormArrayOptions) {
    super(interviewTeamworkSchema, InterviewTeamwork, options);
  }

  protected override createItemGroup() {
    return new InterviewTeamworkFormGroup();
  }

  get array(): InterviewTeamwork[] {
    return this.controls.map(
      (group: InterviewTeamworkFormGroup) => group.object,
    );
  }
}

export class InterviewTeamworkPersistedArray extends PersistedArray<InterviewTeamwork> {
  readonly entityName = 'InterviewTeamwork' as const;

  constructor(options?: PersistedArrayOptions) {
    super(InterviewTeamwork, options);
  }
}
